import React from "react";

interface IDropZoneProps {
    isHidden: boolean;
}

const DropZone: React.FC<IDropZoneProps> = ({ isHidden }) => <div className={`drop-zone ${isHidden ? "hidden" : ""}`} />;

export default DropZone;
